export default {
	reports: {
		contact: 'Contact',
		reportedBy: 'Reported by',
		callback_number: 'Callback number',
		sendEmail: 'Email',
		emails: '@:common.emails',
		to: 'to',
		subject: '@:common.subject',
		publicLabel: 'public',
		emailConflict: 'Internal marking is not possible when sending an email',
		markAsInternal: 'Mark comment as internal',
		internalInfo: 'The comment will only be visible to the property management',
		visibleToAdmin: 'This is only visible to the property management',
		linkData: 'Link data',
		category: '@:common.category',
		subCategory: 'Subcategory',
		createReport: 'Create Report',
		disabledNotifications:
			'The sending of notifications is disabled. Please enable it first in order to use this feature',
		rejectionReasonOptional: 'Provide reason for rejection (optional)',
		dataChangeRequestFrom: 'Data Change Request from ',
		assignToMe: 'Assign to me',
		callbackNumber: 'Phone number for inquiries',
		resetFilters: 'Reset filters',
		alternativeCallbackNumber: 'Alternative phone number for inquiries',
		thankYouQuestion:
			'Thank you for using our digital platform. What would you like to report?',
		enterDamageCategory: 'Please specify the category of the damage here.',
		importantNote:
			'Important: For all categories, except the general message, additional questions will follow.',
		specifyDamage: 'Now define the damage in more detail.',
		internalNotes:
			'Internally marked reports are only visible to the property manager and team members.',
		salutation: 'Dear Sir or Madam,',
		man: 'Mr.',
		woman: 'Mrs.',
		male: 'Dear',
		female: 'Dear',
		reporterNoAccountNoNotification:
			'Reporter has no account – no notification possible',
		createdBy: 'Created by',
		createdInternally: 'Created internally',
		createdInternallyBy: 'Created internally by {name}',
		createdInternallyEditable:
			'Created internally – report text editable by team/admin.',
		createdByReporterReadonly:
			'Reported by the reporter themselves – report text is not editable.',
		commentGuestNeedsEmail:
			'For a guest to see this message, email sending must be selected.',
		commentDigestInfoHourly:
			'Comment notifications are collected and sent hourly in a single email.',
		commentDigestInfo:
			'Comment notifications are collected and sent about every {minutes} minutes in a single email.',
		commentDigestInfoDaily:
			'Comment notifications are collected and sent once a day in a single email.',
		creatorRole: {
			admin: 'Administrator',
			team: 'Team member',
			person: 'Person',
		},
	},
}
